import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { FALLBACK_AVATAR, fallbackTo, uploadUrl } from "../constants";

TimeAgo.addDefaultLocale(en);

const PostAuthor = ({ authorID, createdAt }) => {
  const [author, setAuthor] = useState({});

  useEffect(() => {
    const getAuthor = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/${authorID}`);
        setAuthor(response?.data);
      } catch (err) {
        console.log(err);
      }
    };
    getAuthor();
  }, [authorID]);

  return (
    <Link to={`/posts/users/${authorID}`} className="author-chip">
      <span className="avatar">
        <img src={uploadUrl(author?.avatar)} alt="" onError={fallbackTo(FALLBACK_AVATAR)} />
      </span>
      <span>
        <span className="author-chip__name">{author?.name || "—"}</span>
        {createdAt && (
          <span className="author-chip__time">
            <ReactTimeAgo date={new Date(createdAt)} locale="en-US" />
          </span>
        )}
      </span>
    </Link>
  );
};

export default PostAuthor;
